// extracted by mini-css-extract-plugin
export default {"field":"CommentCreate_field__AO5Pi","controls":"CommentCreate_controls__3ywLa"};